module.exports = __webpack_public_path__ + "static/media/watch-now-button.f5332dd9.svg";